export const CREDIT_TOPUP_PACKS = [
  { planType: "credit_topup_10", credits: 10, price: 19.99, label: "10 Credits" },
  { planType: "credit_topup_20", credits: 20, price: 34.99, label: "20 Credits" },
  { planType: "credit_topup_30", credits: 30, price: 49.99, label: "30 Credits" },
];

export const isCreditTopUpPlan = (planType) =>
  CREDIT_TOPUP_PACKS.some((pack) => pack.planType === planType);
